module.exports = __webpack_public_path__ + "static/media/billing.5245cbb3.svg";